module.exports = __webpack_public_path__ + "static/es-3049dcd75fd35fdfaef1d2f20d475e98.svg";